<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Onboarding</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Onboarding</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
    <div class="col-lg-12">
      <app-button
        (click)="openCreateOnboardingDialog()"
        text="New Onboarding"
      ></app-button>
    </div>

    <div class="col-lg-12">
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Ex. ium"
          #input
        />
      </mat-form-field>

      <mat-progress-bar
        mode="indeterminate"
        *ngIf="loading"
      ></mat-progress-bar>

      <mat-table [dataSource]="dataSource$ | async" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="organisation.name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.organisation.name }}
          </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="organisation.tag">
          <mat-header-cell *matHeaderCellDef> Tag </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.organisation.tag }}
          </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element?.status }} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          matRipple
          *matRowDef="let row; columns: displayedColumns"
          (click)="handleClick(row)"
        ></mat-row>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell center" colspan="4">
            No data matching the filter "{{ input.value }}"
          </td>
        </tr>
      </mat-table>
    </div>
  </div>
</section>
<!-- /.content -->
